module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.8193/js/img/OperationsHub_Icon.svg"